import Button from 'domains/core/components/Button';
import WarningSnackbar from 'domains/core/components/Snackbars/WarningSnackbar/WarningSnackbar';
import { WarningType } from '../hooks/useAssessmentValidation';

type ValidationWarningProps = {
    warningMessage: string | null;
    warningType: WarningType;
    onClose: () => void;
    onRemoveAssessment: () => void;
    onSelectAssessment: () => void;
};

const ValidationWarning = ({
    warningMessage,
    warningType,
    onClose,
    onRemoveAssessment,
    onSelectAssessment,
}: ValidationWarningProps) => {
    if (!warningMessage) return null;

    const getActionButton = () => {
        if (warningType === WarningType.MISSING_TAG) {
            return (
                <Button color="inherit" onClick={onRemoveAssessment}>
                    Remove Assessment
                </Button>
            );
        }

        if (warningType === WarningType.MISSING_ASSESSMENT || warningType === WarningType.INVALID_ASSESSMENT) {
            return (
                <Button color="inherit" onClick={onSelectAssessment}>
                    {warningType === WarningType.INVALID_ASSESSMENT ? 'Change Assessment' : 'Select Assessment'}
                </Button>
            );
        }

        return undefined;
    };

    return <WarningSnackbar warningMessage={warningMessage} onClose={onClose} action={getActionButton()} />;
};

export default ValidationWarning;
